import { Flex, Heading } from '@iziwork/design-system';
import React, { FC } from 'react';

import { DownloadApp } from '~/components/DownloadApp';
import { useTranslation } from '~/hooks';

import { ApplyCloseButtonProps } from '../types';

type ApplyAppliedBodyProps = ApplyCloseButtonProps;

export const ApplyAppliedBody: FC<ApplyAppliedBodyProps> = () => {
  const { t } = useTranslation();

  return (
    <Flex.Column space="m">
      <Heading textAlign="center" variant="subtitle">
        {t('apply.subtitle_download_app')}
      </Heading>
      <DownloadApp justifyContent="center" />
    </Flex.Column>
  );
};
